import React from 'react'
import config from '../config/config'
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react'

const Headerai = ({ isWhiteLable, domain }) => {
    const state = useSelector((state) => state);
    // console.log(state.app.contextData.companyLogo, 'isWhitelabel')
    const [data, setData] = useState('');

    const domainlist = ['dev.zyratalk.com', 'uat.zyratalk.com', 'zyratalk.com', 'localhost'];
    const domaina = !domainlist.includes(window.location.hostname) ? window.location.hostname : config.baseurl;
    const domains = (window.location.hostname)


    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 1) {
                document.querySelector('header').classList.add('sticky');
            } else {
                document.querySelector('header').classList.remove('sticky');
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {

        const formData = new FormData();
        formData.append('domain', "https://" + window.location.hostname);
        if (formData) {
            fetch(`${config.baseurl}/newengage/public/api/getPartnerCompanyLogo`, {
                method: 'POST',

                body: formData
                // JSON.stringify({
                //     domain: formData
                // })
            })
                .then(response => response.json())
                .then(data => {
                    setData(data?.data); // Update the logoUrl state with the response data
                })
                .catch(error => {
                    console.error(error); // Handle any errors here
                });
        } else {
            console.log('error')
        }
    }, [domains]);


    const [isHamburgerActive, setHamburgerActive] = useState(false);

    const handleHamburgerClick = () => {
        setHamburgerActive(!isHamburgerActive);
    };


    return (
        <>
<header class={`main-header ${isWhiteLable && `whitelabelheader`}`}>
<nav class="navbar navbar-expand-lg bg-white">
    <div class="container headcontainer" id="headcontainer">
      {isWhiteLable ? <>
        {!data?.reseller_logo || data?.reseller_logo === '' ?
            <> </> :
            <a class="navbar-brand">
                {/* <img src={`${config.baseurl}/assets/images/logo.svg`} alt="logo" class="img-fluid" /> */}

                <img src={`${config.baseurl}/assets/images/resellerLogo/${data?.reseller_logo}`} alt="logo" class="img-fluid" />
            </a>
        }
    </>
        :
        <>
        <a class="navbar-brand" href={`${config.baseurl}`}>
            <img src={`${config.baseurl}/assets/newweb/images/zyra_log_ev.svg`} alt="logo" class="img-fluid" />
        </a>
        </>}

        {isWhiteLable ?
          <></>:
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                  </button>
        // <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        // <span class="navbar-toggler-icon"></span>
    //   </button>
      }

      {isWhiteLable ?
        <><div class="collapse navbar-collapse" id="navbarSupportedContent">
          
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item">
              <a  class="nav-link" href={"https://" + window.location.hostname + "/signin"}>Sign In</a>
          </li>
          </ul>
        </div></>
        :<>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul id="nav-head" class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" href={`${config.baseurl}/request-demo`}>Get a Demo</a>
            </li>
           
            <li class="nav-item">
              <a class="nav-link" aria-current="page" href={`${config.baseurl}/partners`}>Partners</a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Use Cases
              </a>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href={`${config.baseurl}/automate-customer-support`}>Automate Customer Support</a></li>
                <li><a class="dropdown-item" href={`${config.baseurl}/increase-online-leads`}>Increase Online Leads</a></li>
                <li><a class="dropdown-item" href={`${config.baseurl}/improved-hiring-process`}>Improved Hiring Process</a></li> 
              </ul>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" href={`${config.baseurl}/playground`}>Playground</a>
            </li>
          </ul>
          <ul class="navbar-nav ms-lg-4">
          <li class="nav-item">
              <a  class="nav-link" href={`${config.baseurl}/sign-in`}>Sign In</a>
          </li>
          <li class="nav-item">
          <a href={`${config.baseurl}/request-demo`} class="nav-link btn btn-primary sign-up-btn fw-bold px-4 text-white">Get Started</a>
          </li>
          </ul>
        </div>
        </>}
       
      </div>
    
  </nav>
</header>

</>

    )
}

export default Headerai